import * as React from 'react'
import { Formik, Form, Field } from 'formik'
import { FormiikField } from '$views/components/Forms/FormiikField'
import { Block, Button, Text } from '$views/components'
import { Checkbox } from '$views/components/Checkbox'
import { Link } from '$views/components/Link'
import { contactStepFormSchema } from '$views/RecommendationsForms/BroadcastForm/ContactStep/ContactStepForm/ContactStepForm.validator'
import { BroadcastContactFormValues } from '$views/RecommendationsForms/BroadcastForm/ContactStep/ContactStepForm/ContactStepForm.model'

interface Props {
  onSubmit: (customerRegistration: BroadcastContactFormValues) => void
  isTermsAndPolicyAccept: boolean
  setTermsAndPolicyAccept: () => void
  onClickPrivacyPolicy: () => void
}

export const ContactStepForm: React.FC<Props> = ({
  onSubmit,
  onClickPrivacyPolicy,
  isTermsAndPolicyAccept,
  setTermsAndPolicyAccept,
}) => {
  return (
    <>
      <Formik
        initialValues={{ email: '', name: '' }}
        onSubmit={onSubmit}
        validateOnChange={true}
        validationSchema={contactStepFormSchema}
        render={() => (
          <Form>
            <Field
              name="email"
              component={FormiikField}
              type="text"
              placeholder={'Tu email'}
              primary="true"
              maxLength={100}
            />
            <Field
              name="name"
              component={FormiikField}
              placeholder={'Tu nombre'}
              small="true"
              primary="true"
              maxLength={100}
            />
            <Block flex>
              <Block marginTop="base">
                <Checkbox
                  isChecked={() => isTermsAndPolicyAccept}
                  color="darkGrey"
                  onChange={setTermsAndPolicyAccept}
                  square
                  test-id="termsAndPolicy"
                />
              </Block>
              <Text menu as="p" textAlign="left">
                Acepto el uso de mis datos en Familiados para la prestación de este servicio.{' '}
                <Link href="#" onClick={onClickPrivacyPolicy}>
                  Más información
                </Link>
              </Text>
            </Block>
            <Block marginTop="small">
              <Button primary type="submit" fluid>
                Empezar la búsqueda!
              </Button>
            </Block>
          </Form>
        )}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/ContactStep/ContactStepForm/ContactStepForm.tsx